import {StorageSourceCrud} from './api';
import {StorageSource} from '../../types/organization/StorageSource';

export function resolveWithRandomDelay<T>(value: T) {
    const fail = (window as any)['__pxl_shim_fail'];
    return new Promise<T>((resolve, reject) => {
        setTimeout(
            () => {
                if (fail) {
                    reject(new Error('Simulated failure'));
                } else {
                    resolve(value);
                }
            },
            3000 + Math.random() * 1000,
        );
    });
}

export class CrudShim implements StorageSourceCrud {
    orgId: string;
    private myList: StorageSource[];

    constructor(orgId: string) {
        this.orgId = orgId;
        this.myList = [
            {
                type: 1,
                name: 'AzureBlobStorage',
                origin: 'https://azure.com',
                headers: [
                    {
                        key: 'Authorization',
                        value: 'Bearer <token>',
                    },
                ],
                seo_enabled: true,
            },
            {
                type: 2,
                name: 'AWSBlobStorage',
                origin: 'https://aws.com',
                headers: [
                    {
                        key: 'Authorization',
                        value: 'Bearer <token>',
                    },
                ],
                seo_enabled: true,
            },
            {
                type: 3,
                name: 'GCPBlobStorage',
                origin: 'https://gcp.com',
                headers: [
                    {
                        key: 'Authorization',
                        value: 'Bearer <token>',
                    },
                ],
                seo_enabled: true,
            },
            {
                type: 4,
                name: 'DefaultStorage',
                origin: 'https://default.com',
                headers: [
                    {
                        key: 'Authorization',
                        value: 'Bearer <token>',
                    },
                ],
                seo_enabled: true,
            },
            {
                type: 5,
                name: 'RemoteStorage',
                origin: 'https://remote.com',
                headers: [
                    {
                        key: 'Authorization',
                        value: 'Bearer <token>',
                    },
                ],
                seo_enabled: true,
            },
        ];
    }

    async list(): Promise<StorageSource[]> {
        console.debug('CrudShim: list', this.myList);
        return resolveWithRandomDelay([...this.myList]);
    }

    async create(src: StorageSource): Promise<StorageSource> {
        console.debug('CrudShim: create', src);
        this.myList = [...this.myList, src];
        return resolveWithRandomDelay(src);
    }

    async delete(src: StorageSource | string): Promise<undefined> {
        console.debug('CrudShim: delete', src);
        const name = typeof src === 'string' ? src : src.name;
        this.myList = this.myList.filter((s) => s.name !== name);
        return resolveWithRandomDelay(undefined);
    }

    async update(src: StorageSource): Promise<StorageSource> {
        console.debug('CrudShim: update', src);
        this.myList = this.myList.map((s) => (s.name === src.name ? src : s));
        return resolveWithRandomDelay(src);
    }
}
